import { render, staticRenderFns } from "./RejectPurplePhoneContact.vue?vue&type=template&id=7c190fe8&"
import script from "./RejectPurplePhoneContact.vue?vue&type=script&lang=js&"
export * from "./RejectPurplePhoneContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports